import { render, staticRenderFns } from "./Huizhang.vue?vue&type=template&id=2dcbae86&scoped=true&"
import script from "./Huizhang.vue?vue&type=script&lang=js&"
export * from "./Huizhang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcbae86",
  null
  
)

export default component.exports